export const ticketStatusesRoutes = {
  list: "",
  create: "new",
  edit: ":id/edit",
} as const;
